/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {NavigationGuard} from 'vue-router';
import {RawLocation, Route} from 'vue-router/types/router';
import {Vue} from 'vue-property-decorator';

/**
 * Guard to configure title.
 *
 * @param to
 * @param from
 * @param next
 */
export const configurationGuard: NavigationGuard = (
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void,
): void => {
    document.title = Vue.i18n.translate('app.title', {}) || 'Thememaker\'s Toolkit';
    next();
};
